
import { useState, useEffect } from 'react';
import { Notification } from '@/types/notifications';

export const useNotificationCounter = (notifications: Notification[]) => {
  const [unreadCount, setUnreadCount] = useState(0);

  // Update unread count whenever notifications change
  useEffect(() => {
    const unread = notifications.filter(n => !n.is_read).length;
    setUnreadCount(unread);
  }, [notifications]);

  return { unreadCount, setUnreadCount };
};
